import { Col, Form } from "antd";
import { MazakaSelectProps } from "models/Client/MazakaSelectProps";
import { FC } from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

const GeneralPhoneNumber2: FC<MazakaSelectProps> = (props) => {
  const validatePhoneNumber = async (_: any, value: string) => {
    if (!value || value.length < 12) {
      return Promise.reject(new Error("Telefon formatı geçersiz"));
    }

  

    return Promise.resolve();
  };

  return (
    <>
      <Col
        span={props.span ?? 24}
        md={props.md}
        sm={props.sm}
        lg={props.lg}
        xl={props.xl}
        xxl={props.xxl}
        xs={props.xs}
      >
        <Form.Item
          label={props.label}
          name={props.name}
          className={props.className}
          rules={[...(props.rules || []), { validator: validatePhoneNumber }]}
        >
          <PhoneInput
            value={props.value}
            onChange={async(value, data: any) => {
              if (value && data) {
                let numberPrefix = data?.dialCode || "";
                let valueAsString = value.toString();
                let numberBody = valueAsString.replace(`${numberPrefix}`, "");
                props.form?.setFieldValue(
                  props.name,
                  `${numberPrefix}+${numberBody}`
                );
                if (value.length === 12&&(props.setInitialDataWithPhone ||props.isExistingUser)) {
      
                  props.setIsExternalLading(true);
                  try {
                    const response = await props.setInitialDataWithPhoneService(numberPrefix,numberBody);
                   
                    if (response?.data) {
                      let data = { ...response?.data };
                      if(props.setInitialDataWithPhone)
                      {
                        props.form?.setFieldsValue({
                          ...data,
                        });
                      }
                      props.setIsFindUser(true);
                    }
                    else{
                     
                      
                      props.setIsFindUser(false);
                    }
                  } catch (error: any) {
                    
                    props.setIsFindUser(false);
                    console.log("Somethings wrong during finding user");
                  } finally {
                    props.setIsExternalLading(false);
                  }
                }
               
              }
            }}
            enableSearch={true}
            placeholder={props.placeholder}
            country={props.country ?? "tr"}
            disabled={props.disabled}
            inputClass={"!w-full " + props.inputClass}
            containerClass={props.containerClass}
            inputProps={{
              name: props.name,
              required: props.required,
            }}
          />
        </Form.Item>
      </Col>
    </>
  );
};

export default GeneralPhoneNumber2;
